import React from "react";
import { createContext, useState } from "react";

export const NavToggleContext = createContext({});

export const NavToggleProvider = (props) => {
  const { children } = props;
  const [toggle, setToggle] = useState(false);

  return (
    <NavToggleContext.Provider value={{ toggle, setToggle }}>
      {children}
    </NavToggleContext.Provider>
  );
};
